import { isEmpty, pickBy } from 'lodash';
import {
  decodeBoolean,
  decodeDelimitedArray,
  decodeDelimitedNumericArray,
  decodeNumericObject,
  decodeObject,
  encodeBoolean,
  encodeDelimitedArray,
  encodeDelimitedNumericArray,
  encodeNumericObject,
  encodeObject
} from 'use-query-params';

export type IdFilter = number[] | undefined;
export const IdFilterParam = {
  encode: (obj: IdFilter): string | null | undefined => encodeDelimitedNumericArray(obj, '-'),
  decode: (objStr: string | string[] | null | undefined): IdFilter =>
    decodeDelimitedNumericArray(objStr, '-')?.filter((o) => o !== null) as number[] | undefined
};

export type StringFilter = string[] | undefined;
export const StringFilterParam = {
  encode: (obj: StringFilter): string | null | undefined => encodeDelimitedArray(obj, ','),
  decode: (objStr: string | string[] | null | undefined): StringFilter =>
    decodeDelimitedArray(objStr, ',')?.filter((o) => o !== null) as string[] | undefined
};

export type Sort = { id: string; desc?: boolean }[] | undefined;
export const SortParam = {
  encode: (array: Sort): string | null | undefined =>
    encodeDelimitedArray(
      array?.map((o) => encodeObject({ [o.id]: encodeBoolean(!!o.desc) }) as string),
      ','
    ),
  decode: (objStr: string | string[] | null | undefined): Sort =>
    decodeDelimitedArray(objStr, ',')
      ?.map((s) => {
        const simpleObject = decodeObject(s);
        return {
          id: Object.keys(simpleObject || {})[0],
          desc: !!decodeBoolean(Object.values(simpleObject || {})[0])
        };
      })
      ?.filter((o) => o !== null)
};

export type Page = { pageSize?: number | null; pageIndex?: number | null };
export const PageParam = {
  encode: (object: Page): string | null | undefined => encodeNumericObject(object),
  decode: (objStr: string | string[] | null | undefined): Page => decodeNumericObject(objStr) || {}
};

export type DateFilter = { start?: string | null; end?: string | null } | undefined;
export const DateFilterParam = {
  encode: (obj: DateFilter): string | null | undefined =>
    encodeObject(
      pickBy(obj, (v) => v !== undefined),
      '->'
    ),
  decode: (objStr: string | null | undefined): DateFilter => {
    const dates = pickBy(decodeObject(objStr, '->'), (v) => v !== undefined && v !== 'undefined');
    return isEmpty(dates) ? undefined : dates;
  }
};
